import axios from "axios";
import { BASE_URL } from "../config/apiConfig";
import { AuthService } from "./authService";
import { DEMO_CONFIG } from "../demo/demo.config";

export const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: "application/json, text/plain, */*",
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((request) => {
  if (DEMO_CONFIG.demoMode) {
    return Promise.reject(
      new axios.CanceledError("Network requests are disabled in demo mode"),
    );
  }

  const token = AuthService.getToken();

  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  } else {
    delete request.headers.Authorization;
  }

  return request;
});
